module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/soc_1-6f9c0a4be447b22fd76ab3cb82ced1f8.svg";